import {
  SOCIAL_PREVIEW,
  SOCIAL_NEW,
  SOCIAL_UPDATE,
  SOCIAL_REMOVE,
  SOCIAL_PROCESS_SUCCESS,
  SOCIAL_DATASOURCE_SUCCESS,
  SOCIAL_SEARCH,
  SOCIAL_PROCESS_RESET
} from "constants/ActionTypes"

const INIT_STATE = {
  loader: false,
  dataSerialize:{},
  dataSource:[],
  process:{},
  keyword:''
}

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SOCIAL_PREVIEW: {
      return {
        ...state,
        loader: false,
        process:{status:false,action:"",message:""}
      }
    }
    case SOCIAL_NEW: {
      return {
          ...state,
          loader: true,
          process:{status:false,action:"",message:""}
      }
    }
    case SOCIAL_UPDATE:{
        return{
          ...state,
          loader:true,
          process:{status:false,action:"",message:""},
          dataSerialize:action.payload
        }
    }
    case SOCIAL_REMOVE: {
      return {
          ...state,
          loader: false,
          process:{status:false,action:"",message:""}
      }
    }
    case SOCIAL_SEARCH:{
        return {
            ...state,
            loader:false,
            keyword:action.payload
        }
    }
    case SOCIAL_PROCESS_SUCCESS:{
      return{
        ...state,
        loader:false,
        process:action.payload
      }
    }
    case SOCIAL_DATASOURCE_SUCCESS:{
        return {
            ...state,
            loader: false,
            dataSource: action.payload
        }
    }
    case SOCIAL_PROCESS_RESET:{
      return{
        ...state,
        process:{}
      }
    }
    default:
      return state
  }
}